<!-- <div class="panel-details">
    <ng-container *ngIf="mode !== 'UnassignedTasks'">
        <h4 class="header">
            Pick Up
        </h4>
        <ng-container
            *ngTemplateOutlet="pickDropSection; context: { locations: task.pickupLocations, pickDrop: PICK_DROP.pickup, pickDropNotes: task.pickupNotes }">
        </ng-container>
        <hr />
        <h4 class="header">
            Drop Off
        </h4>
        <ng-container
            *ngTemplateOutlet="pickDropSection; context: { locations: task.dropoffLocations, pickDrop: PICK_DROP.dropoff, pickDropNotes: task.dropoffNotes }">
        </ng-container>
    </ng-container>
    <div class="action-button" [ngSwitch]="mode">
        <button *ngSwitchCase="'MyTasks'" type="button" mat-raised-button color="primary"
            (click)="endTerminalTask(task)">
            <span>End Task</span>
            <mat-icon>remove_circle_outline</mat-icon>
        </button>

        <ng-container *ngSwitchCase="'Dispatch'"></ng-container>

        <button *ngSwitchDefault type="button" mat-raised-button color="primary" (click)="assignTerminalTask(task)">
            <span>
                Assign Terminal Task
            </span>
            <mat-icon>playlist_add</mat-icon>
        </button>
    </div>
</div>


<ng-template #pickDropSection let-locations="locations" let-pickDrop="pickDrop" let-pickDropNotes="pickDropNotes">
    <div class="details-section">
        <div *ngFor="let location of locations" class="row">
            <mat-label>{{ location.location }}</mat-label>
            <div class="count">
                <button class="decrease" mat-flat-button [disabled]="!!location.completedTime"
                    (click)="pickDropPassengers(location, INC_DEC.decrease, TERMINAL_RUN_TYPE.terminalCounter, pickDrop)">
                    <mat-icon>remove_circle_outline</mat-icon>
                </button>
                <input matInput type="text" [disabled]="!!location.completedTime" readonly
                    [value]="location.passengerCount" />
                <button class="increase" mat-flat-button [disabled]="!!location.completedTime"
                    (click)="pickDropPassengers(location, INC_DEC.increase, TERMINAL_RUN_TYPE.terminalCounter, pickDrop)">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>
            </div>
            <div class="select-button">
                <button mat-flat-button *ngIf="!!location.completedTime"
                    (click)="revertConfirmPickupDropOff(location, pickDrop)"
                    [ngClass]="{'selected': !!location.completedTime}">
                    <mat-icon class="material-icons-outlined">
                        check_circle</mat-icon>
                </button>

                <button mat-stroked-button *ngIf="!location.completedTime"
                    [ngClass]="{'selected': !!location.completedTime}"
                    (click)="confirmPickupDropOff(location, pickDrop)">
                    <mat-icon class="material-icons-outlined">
                        circle_outlined</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="pickup-notes-section">
        <div>
            <mat-label>Coordinator Notes:</mat-label>
            <textarea matInput value="{{getCoordNotes(pickDrop, pickDropNotes)}}" rows="5"  #bob (blur)="updateCoordinatorNotes(pickDrop, bob.value)"></textarea>
        </div>
        <div>
            <mat-label>Driver Notes:</mat-label>
            <textarea matInput value="{{getDriverNotes(pickDrop, pickDropNotes)}}" rows="5" #tom (blur)="updateDriverNotes(pickDrop, tom.value)"></textarea>
        </div>
    </div>
</ng-template> -->






<div class="panel-details">
    <div *ngIf="mode !== 'UnassignedTasks'">
        <h4 class="header">
            Pick Up <span class="processing-terminal-time" [hidden]="!loadPickup">Processing...</span>
        </h4>
        <div class="details-section">
            <div *ngFor="let location of task.pickupLocations" class="row">
                <mat-label>{{ location.location }}</mat-label>
                <div class="count">
                    <button class="decrease" mat-flat-button [disabled]="!!location.completedTime && mode !== 'Dispatch'"
                        (click)="pickDropPassengers(location, INC_DEC.decrease, TERMINAL_RUN_TYPE.terminalCounter, PICK_DROP.pickup)">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                    <input matInput type="text" [disabled]="!!location.completedTime && mode !== 'Dispatch'"
                        [value]="location.passengerCount" />
                    <button class="increase" mat-flat-button [disabled]="!!location.completedTime && mode !== 'Dispatch'"
                        (click)="pickDropPassengers(location, INC_DEC.increase, TERMINAL_RUN_TYPE.terminalCounter, PICK_DROP.pickup)">
                        <mat-icon>add_circle_outline</mat-icon>
                    </button>
                </div>
                <div class="select-button" *ngIf="mode !== 'Dispatch'">
                    <button mat-flat-button *ngIf="!!location.completedTime"
                        (click)="revertConfirmPickupDropOff(location, PICK_DROP.pickup)"
                        [ngClass]="{'selected': !!location.completedTime}">
                        <mat-icon class="material-icons-outlined">
                            check_circle</mat-icon>
                    </button>

                    <button mat-stroked-button *ngIf="!location.completedTime"
                        [ngClass]="{'selected': !!location.completedTime}"
                        (click)="confirmPickupDropOff(location, PICK_DROP.pickup)">
                        <mat-icon class="material-icons-outlined">
                            circle_outlined</mat-icon>
                    </button>
                </div>
                <div class="terminal-time-input" *ngIf="mode === 'Dispatch'">
                    <input matInput type="text" appTimeInputMask [value]="extractTime(location?.completedTime || null)" #pickupTimeVal (blur)="updateTerminalTime(location, pickupTimeVal.value, PICK_DROP.pickup, task.taskName)">
                </div>
            </div>
        </div>

        <div class="pickup-notes-section">
            <div>
                <mat-label>Coordinator Notes:</mat-label>
                <textarea matInput
                [formControl]="coordNotesPickupCtrl"
                rows="5"
                #coordNotesPickupCtrlVal
                (blur)="updateCoordinatorNotes(PICK_DROP.pickup, coordNotesPickupCtrlVal.value)"></textarea>
            </div>
            <div>
                <mat-label>Driver Notes:</mat-label>
                <textarea matInput
                [formControl]="driverNotesPickupCtrl"
                rows="5"
                #driverNotesPickupCtrlVal
                (blur)="updateDriverNotes(PICK_DROP.pickup, driverNotesPickupCtrlVal.value)"></textarea>
            </div>
        </div>
        <hr />





        <h4 class="header">
            Drop Off <span class="processing-terminal-time" [hidden]="!loadDropoff">Processing...</span>
        </h4>
        <!-- <ng-container
            *ngTemplateOutlet="pickDropSection; context: { locations: task.dropoffLocations, pickDrop: PICK_DROP.dropoff, pickDropNotes: task.dropoffNotes }">
        </ng-container> -->
        <div class="details-section">
            <div *ngFor="let location of task.dropoffLocations" class="row">
                <mat-label>{{ location.location }}</mat-label>
                <div class="count">
                    <button class="decrease" mat-flat-button [disabled]="!!location.completedTime && mode !== 'Dispatch'"
                        (click)="pickDropPassengers(location, INC_DEC.decrease, TERMINAL_RUN_TYPE.terminalCounter, PICK_DROP.dropoff)">
                        <mat-icon>remove_circle_outline</mat-icon>
                    </button>
                    <input matInput type="text" [disabled]="!!location.completedTime && mode !== 'Dispatch'" readonly
                        [value]="location.passengerCount" />
                    <button class="increase" mat-flat-button [disabled]="!!location.completedTime && mode !== 'Dispatch'"
                        (click)="pickDropPassengers(location, INC_DEC.increase, TERMINAL_RUN_TYPE.terminalCounter, PICK_DROP.dropoff)">
                        <mat-icon>add_circle_outline</mat-icon>
                    </button>
                </div>
                <div class="select-button" *ngIf="mode !== 'Dispatch'">
                    <button mat-flat-button *ngIf="!!location.completedTime"
                        (click)="revertConfirmPickupDropOff(location, PICK_DROP.dropoff)"
                        [ngClass]="{'selected': !!location.completedTime}">
                        <mat-icon class="material-icons-outlined">
                            check_circle</mat-icon>
                    </button>

                    <button mat-stroked-button *ngIf="!location.completedTime"
                        [ngClass]="{'selected': !!location.completedTime}"
                        (click)="confirmPickupDropOff(location, PICK_DROP.dropoff)">
                        <mat-icon class="material-icons-outlined">
                            circle_outlined</mat-icon>
                    </button>
                </div>
                <div class="terminal-time-input" *ngIf="mode === 'Dispatch'">
                    <input matInput type="text" appTimeInputMask [value]="extractTime(location?.completedTime || null)" #dropoffTimeVal (blur)="updateTerminalTime(location, dropoffTimeVal.value, PICK_DROP.dropoff, task.taskName)">

                </div>
            </div>
        </div>

        <div class="pickup-notes-section">
            <div>
                <mat-label>Coordinator Notes:</mat-label>
                <textarea matInput
                [formControl]="coordNotesDropoffCtrl"
                rows="5"
                #coordNotesDropoffCtrlVal
                (blur)="updateCoordinatorNotes(PICK_DROP.dropoff, coordNotesDropoffCtrlVal.value)"></textarea>
            </div>
            <div>
                <mat-label>Driver Notes:</mat-label>
                <textarea matInput
                [formControl]="driverNotesDropoffCtrl"
                rows="5"
                #driverNotesDropoffCtrlVal
                (blur)="updateDriverNotes(PICK_DROP.dropoff, driverNotesDropoffCtrlVal.value)"></textarea>
            </div>
        </div>

    </div>
    <div class="action-button" [ngSwitch]="mode">
        <ng-container *ngSwitchCase="'MyTasks'">
            <button *ngIf="canDeleteTask(task)" type="button" mat-raised-button class="unassign-button" (click)="deleteTask.emit()" >
                <span>Delete Task</span>
                <mat-icon>playlist_add</mat-icon>
            </button>

            <button *ngIf="canEndTask(task)" type="button" mat-raised-button color="primary"
                (click)="endTask.emit()">
                <span>End Task</span>
                <mat-icon>remove_circle_outline</mat-icon>
            </button>

            <button *ngIf="canUnassignTask(task)" type="button" class="unassign-button" mat-raised-button (click)="unassignTask.emit()">
            <span>Unassign Task</span>
            <i class="icon-minus-circle-white-inline minus-icon"></i>
          </button>
        </ng-container>

        <ng-container *ngSwitchCase="'Dispatch'"></ng-container>


        <button *ngSwitchDefault type="button" mat-raised-button color="primary" [matMenuTriggerFor]="theMenu" >
            <span>
                Assign Terminal Task
            </span>
            <mat-icon>playlist_add</mat-icon>
        </button>
        <mat-menu #theMenu="matMenu" yPosition="above" (click)="$event.stopPropagation()" >
          <div class="black-text">Please Confirm...</div>
          <div class="btn-bottom-section">
          <button mat-raised-button color="primary" type="button" (click)="assignTerminalTask(task)">Continue</button>
          <button mat-raised-button closeMenu type="button">Cancel</button>
          </div>
        </mat-menu>



    </div>
</div>
